// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <span ng-bind=\"row.entity.OrderReasonValue | invEmpty\"></span>\n</div>\n";
// Exports
module.exports = code;